import { useState } from "react";
import { toast } from "sonner";
import { UserPlus, UserX } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function RemovedMembers({ leagueId, onRestored }) {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const load = async () => {
    try { const { data } = await api.get(`/superadmin/leagues/${leagueId}/removed`); setRows(data); setOpen(true); } catch (e) { toast.error(errMsg(e)); }
  };
  const restore = async (r) => {
    if (!window.confirm(`Réintégrer ${r.display_name} dans la ligue ? Il retrouvera ses pronos et sa place au classement.`)) return;
    try {
      await api.post(`/superadmin/leagues/${leagueId}/members/${r.user_id}/restore`);
      setRows((x) => x.filter((y) => y.user_id !== r.user_id)); toast.success(`${r.display_name} est de retour dans la ligue`); onRestored?.();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-xl border border-white/10 p-3 text-xs" data-testid={`admin-removed-${leagueId}`}>
      <button type="button" onClick={() => (open ? setOpen(false) : load())} className="flex items-center gap-2 font-semibold text-white" data-testid={`admin-removed-toggle-${leagueId}`}>
        <UserX size={14} /> {open ? "Masquer les joueurs retirés" : "Joueurs retirés"}
      </button>
      {open && rows && (
        <ul className="mt-3 divide-y divide-white/[0.06]">
          {rows.map((r) => (
            <li key={r.user_id} className="flex flex-wrap items-center justify-between gap-2 py-2" data-testid={`admin-removed-row-${r.user_id}`}>
              <div className="min-w-0 flex-1">
                <p className="truncate font-semibold text-white">{r.display_name} {r.username && <span className="font-normal text-[#B7F52A]">@{r.username}</span>}</p>
                <p className="truncate text-slate-400">{r.email}</p>
                <p className="text-[11px] text-slate-500" data-testid={`admin-removed-date-${r.user_id}`}>Retiré le {r.removed_at ? fmtDateTime(r.removed_at) : "date inconnue"}</p>
              </div>
              <button type="button" onClick={() => restore(r)} className="mpl-btn-ghost shrink-0 text-xs" data-testid={`admin-removed-restore-${r.user_id}`}><UserPlus size={12} /> Réintégrer</button>
            </li>
          ))}
          {!rows.length && <li className="py-2 text-slate-400">Aucun joueur retiré de cette ligue.</li>}
        </ul>
      )}
    </div>
  );
}
